import SiteHeaderWrapper from './SiteHeaderWrapper';
import MobileHeader from './MobileHeader';
import DesktopHeader from './DesktopHeader';
import SubmitModal from '../Modal';
import { handleClose } from '../Modal/utils';
import MobileAlert from './MobileAlert';

const SiteHeader = ({ props }) => {
  const stateProps = props.stateProps;
  const formikProps = props.formikProps;
  return (
    <>
      <SiteHeaderWrapper>
        <SubmitModal
          stateProps={stateProps}
          formikProps={formikProps}
          handleClose={handleClose}
          message_raw="" />
        <MobileHeader props={props}  />
        <DesktopHeader props={props} />
      </SiteHeaderWrapper>
      <MobileAlert />
    </>
  );
};

export default SiteHeader;
